import React, { Fragment } from 'react'
import { Formatter } from './workFormatter'
import { capitalize } from '../utils/string'
import OPTIONS from '../constants/settingOptions'

export const parseWork = (info, options = {}) => {
    const { issued, author: authors, title: titleArr, page, volume, DOI: doi } = info;

    const journalFullName = info['container-title'][0];
    const journalShortName = info['short-container-title'][0];
    const title = titleArr[0]
    const year = issued['date-parts'][0][0]

    return joinReference({
        authors,
        title,
        journalFullName,
        journalShortName,
        year,
        volume,
        page,
        doi
    }, options)
}

const formatWork = (info, options) => {
    const formatter = new Formatter(options)
    const {
        authors,
        title,
        journalFullName,
        journalShortName,
        year,
        volume,
        page
    } = info;
    return {
        authors: formatter.formatAuthors(authors),
        title: formatter.formatTitle(title),
        journal: formatter.formatJournal(journalFullName, journalShortName),
        year: formatter.formatYear(year),
        volume: formatter.formatVolume(volume),
        page: formatter.formatPage(page),
    }
}

const formatStyle = (style) => {
    const legitStyle = {}
    for (const key of Object.keys(style)) {
        const isBold = style[key].includes(OPTIONS.FONT_STYLE.BOLD)
        const isItalic = style[key].includes(OPTIONS.FONT_STYLE.ITALIC)
        legitStyle[key] = {
            fontWeight: isBold ? 'bold' : 'normal',
            fontStyle: isItalic ? 'italic' : 'normal'
        }
    }
    return legitStyle
}

export const joinReference = (info, options = {}) => {
    const {
        key,
        displays,
        conjunctions,
        positions,
        styles
    } = options
    const { doi } = info
    const legitInfo = formatWork(info, options);
    const legitStyle = formatStyle(styles);
    // 标题以问号结尾时，跳过标题之后的符号
    const doNotShowAfterTitle = legitInfo.title[legitInfo.title.length - 1] === '?'
    if (doNotShowAfterTitle) {
        conjunctions.afterTitle = ''
    }
    const infoToRender = ['authors', 'title', 'journal', 'year', 'volume', 'page']
        .filter((key) => {
            return displays[key]
        })
        .sort((prev, next) => {
            return positions[prev] > positions[next] ? 1 : -1
        })
        .map((key) => {
            const afterKey = `after${capitalize(key)}`;
            return <Fragment key={key}>
                <span style={legitStyle[key]} key={key}>
                    {legitInfo[key]}
                </span>
                <span key={afterKey}>{conjunctions[afterKey]}</span>
            </Fragment>
        })
    return (
        <span key={key} className="resolved" doi={doi}>
            {infoToRender}
        </span>
    )
}



// WEBPACK FOOTER //
// ./src/services/workTransformer.js